import HomeReducer from './HomeReducer';
import UiReducer from './UiReducer';
const rootReducer = {
	ui: UiReducer.reducer,
	home: HomeReducer.reducer,
};

export default rootReducer;
